class Accordion {
  constructor(node) {
    this.rootElement = node;
    this.buttonElement = this.rootElement.querySelector('.c-accordion__trigger');
    this.panelElement = this.rootElement.closest('.c-accordion').querySelector('.c-accordion__panel');

    const controlsId = this.buttonElement.getAttribute('aria-controls');
    this.contentElement = document.getElementById(controlsId);

    this.isOpen = this.buttonElement.getAttribute('aria-expanded') === 'true';

    this.buttonElement.addEventListener('click', this.onButtonClick.bind(this));
  }

  onButtonClick() {
    this.toggle(!this.isOpen);
  }

  toggle(open) {
    if (open === this.isOpen) {
      return;
    }

    this.isOpen = open;
    this.iconElement = this.buttonElement.querySelector('.c-icon');
    if (open) {
      this.buttonElement.setAttribute('aria-expanded', `${open}`);
      this.contentElement.classList.remove('is-collapsed');
      this.iconElement.classList.remove('bi-chevron-down');
      this.iconElement.classList.add('bi-chevron-up');
      this.rootElement.classList.add('is-active');
    }

    // Reset everything on close
    if (!open) {
      this.buttonElement.setAttribute('aria-expanded', `${open}`);
      this.contentElement.classList.add('is-collapsed');
      this.iconElement.classList.add('bi-chevron-down');
      this.iconElement.classList.remove('bi-chevron-up');
      this.rootElement.classList.remove('is-active');
    }

    this.accordionTracking();
  }

  open() {
    this.toggle(true);
  }

  close() {
    this.toggle(false);
  }

  accordionTracking() {
    if (this.panelElement) {
      const data = {
        event: 'event',
        eventCategory: 'Akkordeon',
        eventLabel: '',
        eventAction: 'open'
      };

      const accordionHeader = this.rootElement;
      if (accordionHeader) {
        if (accordionHeader.getAttribute('trigger-gtm-event-label')) {
          data.eventLabel = accordionHeader.getAttribute('trigger-gtm-event-label');
        }
      }

      const buttonElement = this.buttonElement;
      if (data.eventLabel === '' && buttonElement) {
        data.eventLabel = buttonElement.innerText;
      }

      if (this.panelElement.classList.contains('is-collapsed')) {
        data.eventAction = 'close';
      }

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push(data);
    }
  }
}

const accordions = document.querySelectorAll('.c-accordion__header');
accordions.forEach((accordionElement) => {
  new Accordion(accordionElement);
});
